/* global firebase */
import {
  DEV_AUTH,
  SET_PROFILE,
  LOGOUT,
  LOGIN,
  SET_AUTH_PROFILE
} from "./mutations";
const state = {
  dev_authenticated: false,
  auth_profile: null,
  logged_in: false,
  profile: null
};
const getters = {
  auth_profile: state => {
    return state.auth_profile;
  },
  has_verified_mail: state => {
    if (!state.auth_profile) return false;
    if (state.auth_profile.email_verified === undefined) return false;
    return state.auth_profile.email_verified;
  },
  is_logged_in: state => {
    return state.logged_in;
  },
  is_dev_authenticated: state => {
    return state.dev_authenticated;
  }
};
const mutations = {
  [LOGIN](state) {
    state.logged_in = true;
  },
  [SET_AUTH_PROFILE](state, data) {
    if (!data) state.auth_profile = null;
    else
      state.auth_profile = {
        uid: data.uid,
        email: data.email,
        email_verified: data.emailVerified
      };
  },
  [SET_PROFILE](state, data) {
    if (data === null) state.profile = null;
    else
      state.profile = {
        uid: data.uid,
        email: data.email,
        name: data.name === null ? null : data.name,
        profile_picture:
          data.profile_picture === null ? null : data.profile_picture
      };
  },
  [LOGOUT](state) {
    state.logged_in = false;
    state.auth_profile = null;
    state.profile = null;
  },
  [DEV_AUTH](state) {
    state.dev_authenticated = true;
  }
};

const actions = {
  async try_dev_auth({ commit }, data) {
    return new Promise((resolve, reject) => {
      if (state.dev_authenticated) reject({ error: "already_authenticated" });
      let params = { dev_token: data.dev_token, app_id: "vetvise.account" };
      let callable = firebase.app().functions("europe-west1").httpsCallable("Dev_Authentication");
      callable(params).then(result => {
        if (result.data.allowed === true) {
          commit(DEV_AUTH, {});
          resolve();
        } else reject({ error: "could_not_authenticate" });
      });
    });
  },

  async load_profile({ commit }, payload) {
    if (payload && payload.uid && payload.emailVerified) {
      //we can load in the whole profile
      let profile = null;
      return firebase
        .firestore()
        .collection("users")
        .doc(payload.uid)
        .get()
        .then(profileSnapshot => {
          if (profileSnapshot.exists) {
            //profile exists in database
            profile = profileSnapshot.data();
          }
          commit(SET_PROFILE, profile);
          commit(LOGIN);
        })
        .catch(() => {
          commit(SET_PROFILE, profile);
          commit(LOGIN);
        });
    } else {
      if (payload && payload.uid) {
        commit(SET_PROFILE, {});
        commit(LOGIN);
      } else {
        commit(LOGOUT);
      }
    }
  },

  sign_in_with_password({ commit }, data) {
    return new Promise((resolve, reject) => {
      return firebase
        .auth()
        .signInWithEmailAndPassword(data.mail, data.password)
        .then(() => {
          commit(LOGIN);
          resolve();
        })
        .catch(error_message => {
          reject({
            code: error_message.code,
            message: error_message.message
          });
        });
    });
  },

  sign_up_with_mail_and_password({ state }, data) {
    return new Promise((resolve, reject) => {
      if (state.logged_in) {
        reject({ error: "Already Logged In!" });
      }
      firebase.auth().useDeviceLanguage();
      firebase
        .auth()
        .createUserWithEmailAndPassword(data.mail, data.password)
        .then(() => {
          resolve();
        })
        .catch(error_message => {
          if (error_message.code === "auth/network-request_failed") {
            reject({ error: "No Internet!" });
          } else {
            reject({ error: "Other Sign Up Error!" });
          }
        });
    });
  },

  logout({ commit, state }) {
    let callable = firebase.app().functions("europe-west1").httpsCallable("Global_Logout");
    callable().then(() => {
      if (!state.logged_in) return Promise.resolve();
      return new Promise((resolve, reject) => {
        firebase
          .auth()
          .signOut()
          .then(() => {
            commit(LOGOUT);
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    });
  },

  async generate_sso_url(state, data) {
    return new Promise((resolve, reject) => {
      let params = { requesting_app: data };

      let callable = firebase.app().functions("europe-west1").httpsCallable("Request_SSO_URL");
      callable(params)
        .then(result => {
          resolve(result.data.url);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
